<!-- After enabling this please update the css/theme in app.scss file. Find notif-custom-class  -->
<!-- @if (isLoaded && isProduction) {
  <notif-library [timeout]="notificationFadeOutTime" [showLogo]="false"
    position="bottom-right" mobilePosition="bottom" className="notif-custom-class" sseUrl="{{ notificationUrl }}">
  </notif-library>
} -->
<app-header> </app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<!-- @if(pixelConfig.CONSENT_API_KEY.length){
<iframe #iframeRef [src]="pixelUrl" class="desclaimer-iframe" [ngClass]="{'d-none': isDesclaimerClosed}"></iframe>
} -->